import React from 'react';
import BaseImage from '../../../../../../atoms/Image';
import { ImagePropType } from '../../../../../../services/proptypes';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import './Image.css';
var defaultProps = {
  as: 'div',
  src: '',
  background: false,
  altText: '',
  gatsbyImageProps: null,
  children: null
};
export default function Image(_ref) {
  var as = _ref.as,
    src = _ref.src,
    background = _ref.background,
    altText = _ref.altText,
    gatsbyImageProps = _ref.gatsbyImageProps,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(BaseImage, {
    as: as,
    src: src,
    background: background,
    altText: altText,
    gatsbyImageProps: gatsbyImageProps,
    className: "image"
  }, children));
}
Image.defaultProps = defaultProps;